import React, { useState } from "react";
import {
  FirstAds,
  SecondAds,
  MobileUnderCalAds,
} from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة مقاسات حمالة الصدر - اكتشفي مقاس الستيان المثالي";
const DESCRIPTION =
  "اكتشفي مقاس حمالة الصدر المثالي الذي يناسب قوامك بدقة باستخدام آلة حاسبة مقاسات الستيان المتقدمة. أدخلي قياسات الصدر والظهر بعناية للحصول على مقاس حمالة الصدر المناسب لك. سواء كنت تبحثين عن الراحة أو الأناقة، توفر لك هذه الأداة الطريقة الأمثل لاختيار المقاس الصحيح، مما يمنحك الثقة والراحة التي تستحقينها. مثالية للنساء اللواتي يرغبن في الحصول على مقاس الستيان المثالي بكل سهولة ودقة.";
const KEYWORDS =
  "حاسبة مقاسات حمالة الصدر, مقاس الستيان, قياس حمالة الصدر, طريقة قياس الستيان, معرفة مقاس الستيان, مقاسات السنتيانات, مقاس الصدر, قياس الصدر, مقاس ستيان, أداة قياس حمالة الصدر, مقاس الكأس, مقاس الشريط، قياسات الجسم، حمالة صدر مريحة، دعم الصدر، المرأة العصرية.";
const OG_URL = "https://do-calculate.com/calculator/ar/bra_size_calculator/";
const BraSizeCalculator = () => {
  const [bust, setBust] = useState("");
  const [band, setBand] = useState("");
  const [size, setSize] = useState(null);
  const [conversionSize, setConversionSize] = useState({
    size: "",
    location: "US/CA",
    cup: "A",
  });
  const [error, setError] = useState(null);
  const handleBustChange = (event) => {
    setBust(event.target.value);
  };
  const handleBandChange = (event) => {
    setBand(event.target.value);
  };
  const handleConversionChange = (event) => {
    const { name, value } = event.target;
    setConversionSize((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const calculateBraSize = () => {
    const bustNum = parseFloat(bust);
    const bandNum = parseFloat(band);
    if (isNaN(bustNum) || isNaN(bandNum) || bustNum <= 0 || bandNum <= 0) {
      setError("أدخل قيم صحيحة");
      setSize(null);
      return;
    }
    const bandSize = bandNum + 4;
    const cupSize = bustNum - bandSize;
    let cup = "";
    if (cupSize < 1) {
      cup = "AA";
    } else if (cupSize < 2) {
      cup = "A";
    } else if (cupSize < 3) {
      cup = "B";
    } else if (cupSize < 4) {
      cup = "C";
    } else if (cupSize < 5) {
      cup = "D";
    } else {
      cup = "E";
    }
    setSize({
      band: bandSize,
      cup: cup,
    });
    setError(null);
  };
  const convertBraSize = () => {
    const { size, location, cup } = conversionSize;
    if (!size || !cup) {
      setError("أدخل جميع التفاصيل للتحويل");
      return;
    }
    let convertedSize = "";
    let convertedCup = cup;
    const band = parseInt(size.replace(/\D/g, ""), 10);
    switch (location) {
      case "US/CA":
        convertedSize = `${band} ${cup}`;
        break;
      case "UK":
        convertedSize = `${band + 2} ${cup}`;
        break;
      case "EU(EN 13402)":
        convertedSize = `${band + 5} ${cup}`;
        break;
      case "Australia/New Zealand":
        convertedSize = `${band + 4} ${cup}`;
        break;
      case "US/CA (Underbust +4)":
        convertedSize = `${band + 4} ${cup}`;
        break;
      case "UK (Underbust +4)":
        convertedSize = `${band + 6} ${cup}`;
        break;
      case "UK Dress Code":
        convertedSize = `${band - 1} ${cup}`;
        break;
      default:
        convertedSize = `${band} ${cup}`;
    }
    setError(null);
    setConversionSize((prevState) => ({
      ...prevState,
      converted: convertedSize,
    }));
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <p>
                    اكتشفي كيفية تحديد مقاس حمالة الصدر المثالي بسهولة ودقة
                    باستخدام أداة حاسبة مقاسات حمالة الصدر المتقدمة. هذه الأداة
                    تساعدك في حساب المقاس الأمثل بناءً على قياسات الصدر والظهر
                    الخاصة بك. ببساطة، قومي بإدخال قياساتك بدقة، وستحصلين على
                    المقاس المناسب الذي يوفر لك الراحة والدعم المثالي.
                  </p>
                  <p>
                    سواء كنتِ تبحثين عن مقاس الستيان المناسب للملابس اليومية أو
                    للملابس الرياضية، توفر لك هذه الأداة طريقة بسيطة وموثوقة
                    لمعرفة مقاسك. تمنحك الأداة أيضًا نصائح حول كيفية أخذ
                    القياسات بشكل صحيح لضمان الحصول على النتيجة الأكثر دقة. تم
                    تصميمها خصيصًا للنساء اللواتي يرغبن في تعزيز ثقتهن وراحتهن
                    من خلال اختيار المقاس المناسب.
                  </p>
                  <p>
                    احصلي على أفضل مقاس حمالة صدر يناسبك من خلال استخدام هذه
                    الأداة، وتمتعي بالراحة والأناقة التي تستحقينها. من خلال حساب
                    دقيق وسهل، يمكنك التأكد من أن حمالة الصدر التي تختارينها
                    ستناسبك تمامًا وتمنحك الدعم المثالي.
                  </p>
                </div>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}> حاسبة حجم الصدر</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">مقاس الصدر:</label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 38"
                        value={bust}
                        onChange={handleBustChange}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">مقاس الطوق:</label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 34"
                        value={band}
                        onChange={handleBandChange}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br/>                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={calculateBraSize}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== null ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      size && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <h4>
                            <u>النتيجة:</u>
                          </h4>
                          <p>مقاس الطوق: {size.band}</p>
                          <p>مقاس الكأس: {size.cup}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة تحويل حجم حمالة الصدر{" "}
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          {" "}
                          أدخل مقاس حمالة الصدر
                        </label>
                      </b>
                      <input
                        type="text"
                        id="conversionSize"
                        name="size"
                        value={conversionSize.size}
                        onChange={handleConversionChange}
                        className="form-control"
                        style={{ width: "75%" }}
                        placeholder="34B"
                      />
                      <span className="input-group-text ">سم</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الموقع</label>
                      </b>
                      <select
                        id="location"
                        name="location"
                        value={conversionSize.location}
                        onChange={handleConversionChange}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="US/CA">US/CA</option>
                        <option value="UK">UK</option>
                        <option value="EU(EN 13402)">EU (EN 13402)</option>
                        <option value="Australia/New Zealand">
                          Australia/New Zealand
                        </option>
                        <option value="US/CA (Underbust +4)">
                          US/CA (Underbust +4)
                        </option>
                        <option value="UK (Underbust +4)">
                          UK (Underbust +4)
                        </option>
                        <option value="UK Dress Code">UK Dress Code</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">حجم الكأس</label>
                      </b>
                      <select
                        id="cup"
                        name="cup"
                        value={conversionSize.cup}
                        onChange={handleConversionChange}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="AA">AA</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="DD/E">DD/E</option>
                        <option value="DDD/F">DDD/F</option>
                        <option value="DDDD/G">DDDD/G</option>
                        <option value="H">H</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={convertBraSize}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== null ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      conversionSize.converted && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <h4>
                            <u>النتيجة:</u>
                          </h4>
                          <p>{conversionSize.converted}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو حجم حمالة الصدر؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                مقاس حمالة الصدر هو قياس يتكون من رقم وحرف. الرقم يمثل محيط صدرك
                تحت الصدر مباشرة، والحرف يمثل حجم كوب حمالة الصدر. يتم تحديد
                المقاس الصحيح من خلال قياسات محيط الصدر وحجم الكوب.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                لماذا من المهم اختيار مقاس حمالة الصدر الصحيح؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                اختيار مقاس حمالة الصدر الصحيح له أهمية كبيرة للصحة والراحة.
                حمالة الصدر غير المناسبة يمكن أن تسبب آلامًا في الظهر والرقبة،
                وتؤثر على الدورة الدموية، وتسبب تهيجًا في الجلد. بالإضافة إلى
                ذلك، فإن حمالة الصدر المناسبة تعزز الثقة بالنفس وتمنحك مظهرًا
                أفضل.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف أقيس مقاسات جسدي للحصول على المقاس الصحيح؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>لقياس مقاسات جسمك بدقة، اتبعي الخطوات التالية:</p>
              <ol>
                <li>استخدمي شريط قياس مرن.</li>
                <li>قيسي محيط صدرك تحت الصدر مباشرة.</li>
                <li>قيسي الجزء الأوسع من صدرك.</li>
                <li>احسبي الفرق بين القياسين للحصول على حجم الكوب.</li>
              </ol>
              <p>
                للحصول على نتائج أكثر دقة، يمكنك الرجوع إلى دليل القياسات
                المرفق مع الآلة الحاسبة أو البحث عن فيديوهات تعليمية.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                نصائح لاختيار حمالة الصدر المثالية
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                بالإضافة إلى اختيار المقاس الصحيح، إليك بعض النصائح لاختيار
                حمالة الصدر المناسبة:
              </p>
              <ul>
                <li>جربي حمالة الصدر قبل شرائها.</li>
                <li>اختاري حمالة الصدر المصنوعة من قماش طبيعي.</li>
                <li>تأكدي من أن الأشرطة مريحة ولا تسبب أي ضغط.</li>
                <li>انتبهي إلى تصميم الكوب وتأكدي من أنه يوفر الدعم الكافي.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BraSizeCalculator;
